import React, { useState, useEffect } from "react";
import "../../../assets/css/gcstudent/studentdashboardlayout/StudentDashboardLayout.css";
import StudentSideBar from "../../../components/gcstudent/studentsidebar/StudentSideBar";
import StudentTopbar from "../../../components/gcstudent/studenttopbar/StudentTopbar";

const SIDEBAR_EXP = 220; // must match --sb-exp in StudentSideBar.css
const SIDEBAR_COL =  64; // must match --sb-col in StudentSideBar.css
const MOBILE_BP   = 992;

const StudentDashboardLayout = ({ children, pageTitle }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile,  setIsMobile]  = useState(window.innerWidth < MOBILE_BP);

  useEffect(() => {
    const fn = () => setIsMobile(window.innerWidth < MOBILE_BP);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);

  // On desktop: body shifts right by sidebar width
  // On mobile:  sidebar is a drawer, body stays full width
  const marginLeft = isMobile ? 0 : collapsed ? SIDEBAR_COL : SIDEBAR_EXP;

  return (
    <div className="gcstudent-layout">

      {/* Sidebar — fixed on left, manages its own mobile drawer */}
      <StudentSideBar onCollapsedChange={setCollapsed} />

      {/* Body — pushed right so it never goes under the sidebar */}
      <div
        className="gcstudent-layout__body"
        style={{ marginLeft: `${marginLeft}px` }}
      >
        {/* Topbar — sticky inside the body column, always full body width */}
        <StudentTopbar
          title={pageTitle || "Student Portal"}
          collapsed={collapsed}
        />

        {/* Page content */}
        <main className="gcstudent-layout__main">
          {children}
        </main>
      </div>

    </div>
  );
};

export default StudentDashboardLayout;